import { Alert, AlertIcon, Button, Flex, FormControl, FormLabel, HStack, Text, useToast } from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { BsBoxArrowInDown, BsX } from 'react-icons/bs'
import { putUpdateUserInfo } from '../../classes/User'
import { reload, useSelectedItemAlertContext } from '../../context/selectedItemAlertContext'
import { useUserContext } from '../../context/userContext'
import { toastErrDesc, toastVal } from '../../utils/toastUtils'
import { SectionForm, SelectUserRole, SelectUserStatus } from '../shared'

const FooterUserInfoAdmin = ({ close }) => {
    // role, status
    const defaultValues = {
        role: { value: 5, label: "ผู้ใช้งาน" },
        status: { value: "ACTIVE", label: "ใช้งานปกติ" }
    }
    const { control, handleSubmit } = useForm({ defaultValues })
    const { itemData, setItemData } = useSelectedItemAlertContext()
    const { userData } = useUserContext()
    const toast = useToast()

    const onSubmit = async (data) => {
        const sendData = {
            role_id: data.role?.value,
            status: data.status?.value
        }
        // console.log(sendData)

        await putUpdateUserInfo(itemData.id, sendData, userData.token)
            .then(res => {
                toast(toastVal({
                    title: "การบันทึกข้อมูลสำเร็จ",
                    description: `บันทึกข้อมูล เรียบร้อยแล้ว`,
                }))
                setItemData((prev) => reload(prev))
                close()
            })
            .catch(error => {
                toast(toastVal({
                    title: "การบันทึกข้อมูล ไม่สำเร็จ",
                    description: toastErrDesc(error),
                    status: "error",
                }))
            })
    }

    return (
        <Flex w="full" direction="column">
            <Alert status="warning">
                <AlertIcon />
                <Text>เฉพาะเจ้าหน้าที่</Text>
            </Alert>
            <form onSubmit={handleSubmit(onSubmit)}>
                <SectionForm header="แก้ไขสิทธิ์และสถานะบัญชี">
                    <HStack w="full" spacing={4}>
                        <FormControl>
                            <FormLabel>สิทธิ์</FormLabel>
                            <SelectUserRole control={control} isClearable={false} disabled={[1]} />
                        </FormControl>
                        <FormControl>
                            <FormLabel>สถานะบัญชี</FormLabel>
                            <SelectUserStatus control={control} isClearable={false} />
                        </FormControl>
                    </HStack>

                </SectionForm>
                <HStack w="full" justify="center">
                    <Button leftIcon={<BsBoxArrowInDown />} colorScheme="blue" type="submit">
                        บันทึกข้อมูล
                    </Button>
                    <Button leftIcon={<BsX />} colorScheme="red" onClick={close}>
                        ยกเลิก
                    </Button>
                </HStack>
            </form>
        </Flex>
    )
}

export default FooterUserInfoAdmin
